module.exports = __webpack_public_path__ + "img/symbol_4.4f3cd4b2.png";